import { PushNotifications } from '@capacitor/push-notifications';
import { LocalNotifications } from '@capacitor/local-notifications';
import { isNative } from './platform';

export async function registerPushNotifications(): Promise<string | null> {
  if (!isNative()) return null;

  const permission = await PushNotifications.requestPermissions();
  if (permission.receive !== 'granted') return null;

  await PushNotifications.register();

  return new Promise((resolve) => {
    PushNotifications.addListener('registration', (token) => resolve(token.value));
    PushNotifications.addListener('registrationError', () => resolve(null));
  });
}

export async function scheduleLocalNotification(title: string, body: string, delaySeconds = 1) {
  await LocalNotifications.requestPermissions();
  await LocalNotifications.schedule({
    notifications: [
      {
        id: Date.now(),
        title,
        body,
        schedule: { at: new Date(Date.now() + delaySeconds * 1000) },
      },
    ],
  });
}
